import React from 'react';
import { ReadOnlyBriefUI } from '@99designs/feature-design-services-brief';
import { ShellInner } from '@99designs/swan-wizard';
import { BriefFragment } from '../../lib';

interface BriefProps {
    brief: BriefFragment;
}

export const Brief = ({ brief }: BriefProps) => {
    const printProductOptions = brief.request?.facts?.serviceProductOptions ?? undefined;

    return (
        <ShellInner>
            <ReadOnlyBriefUI
                brief={brief}
                printProductOptions={printProductOptions}
                mpvId={brief.fulfilment?.mpvId}
                skipJobQuery={false}
            />
        </ShellInner>
    );
};
